import Vue from 'vue'

export default ({
  namespaced: true,
  state: {
    error: {
      errorCategory: {}
    },
    errors: []
  },
  getters: {},
  mutations: {
    ERROR_RPTA(state, error) {
      state.error = error
    },
    ERROR_LIST(state, errors) {
      state.errors = errors
    }
  },
  actions: {
    async saveError(context, error) {
      let formData = new FormData()
      Object.keys(error).forEach((item, i) => {
        if (typeof error[item] === 'object') {
          formData.append(item, JSON.stringify(error[item]))
        } else if (error[item] && error[item].toString().length)
          formData.append(item, error[item])
      });
      return await Vue.axios.post('/api/error/save', formData).then((res) => {
        return res.data
      })
    },
    loadErrors({
      commit,
      rootState
    }) {
      Vue.axios.get('/api/errors/list', {
        params: {
          reviewID: rootState.petra.review.review.id
        }
      }).then((res) => {
        commit('ERROR_LIST', JSON.parse(res.data))
      })
    },
    clearError({
      commit
    }) {
      commit('ERROR_RPTA', {
        errorCategory: {}
      })
    },
    setError({
      commit
    }, error) {
      commit('ERROR_RPTA', error)
    }
  }
})